import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="container-main">
      <div className="footer-grid">
        <div>
          <Logo inverted />
          <p className="footer-tagline">
            DentaPro Clinic — Sănătatea ta dentară, misiunea noastră.
          </p>
        </div>
        <div>
          <h4>Navigare</h4>
          <div className="footer-links">
            <Link to="/" data-testid="footer-link-home">Acasă</Link>
            <Link to="/servicii" data-testid="footer-link-services">Servicii</Link>
            <Link to="/echipa" data-testid="footer-link-team">Echipa</Link>
            <Link to="/contact" data-testid="footer-link-contact">Contact</Link>
          </div>
        </div>
        <div>
          <h4>Contact</h4>
          <div className="footer-contact-item">
            <span>📍</span>
            <span>Strada Mercy 7, Timișoara 300079</span>
          </div>
          <div className="footer-contact-item">
            <span>📞</span>
            <a href="tel:+40256123456">0256 123 456</a>
          </div>
          <div className="footer-contact-item">
            <span>⏰</span>
            <span>Luni–Vineri: 08:00–20:00 | Sâmbătă: 09:00–14:00</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © 2025 DentaPro Clinic. Toate drepturile rezervate.
      </div>
    </div>
  </footer>
);
